import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import utils from './utils';

import { getCounts } from './info';

const status = utils.initStatus([
  'getOffers',
  'getPendingOffers',
  'deleteOffer',
  'addOffer',
  'getOfferDetails',
  'updateOffer',
  'bulkDelete',
  'bulkHide',
]);

const initFilter = () => {
  return {
    keyword: '',
    page: 1,
    skip: 200,
  };
};

const initialState = {
  offers: [],
  pendingOffers: [],
  cachedOffers: [
    {
      page: 1,
      offers: [],
    },
  ],
  offersView: 'grid',
  pendingView: 'grid',

  offerDetails: {
    addOns: [],
  },

  filters: {
    offers: initFilter(),
  },
  status,
};
export const getOffers = createAsyncThunk('offer/getOffers', async (payload, thunkAPI) => {
  try {
    const { currBranch, token } = utils.getAuth(thunkAPI.getState());
    if (!token)
      return utils.rejectWithValue(thunkAPI, null, {
        logout: true,
        message: 'Null token',
      });

    const offersFilter = thunkAPI.getState().offer.filters.offers;

    const res = await axios.get(`/merchant/list/offers/${currBranch}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { ...offersFilter, current: true },
    });

    if (res.status === 200) {
      return res.data;
    }

    return utils.rejectWithValue(thunkAPI, null, {
      message: res.data.message,
      status: res.status,
    });
  } catch (err) {
    return utils.rejectWithValue(thunkAPI, err);
  }
});

export const getPendingOffers = createAsyncThunk(
  'offer/getPendingOffers',
  async (params, thunkAPI) => {
    try {
      const { currBranch, token } = utils.getAuth(thunkAPI.getState());
      if (!token)
        return utils.rejectWithValue(thunkAPI, null, {
          logout: true,
          message: 'Null token',
        });

      // const offersFilter = thunkAPI.getState().offer.filters.offers

      const res = await axios.get(`/merchant/list/offers/${currBranch}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { status: 'pending' },
      });
      if (res.status === 200) {
        return res.data;
      }
      return utils.rejectWithValue(thunkAPI, null, {
        message: res.data.message,
        status: res.status,
      });
    } catch (err) {
      return utils.rejectWithValue(thunkAPI, err);
    }
  },
);

export const addOffer = createAsyncThunk('offer/addOffer', async (offer, thunkAPI) => {
  try {
    const { currBranch, token } = utils.getAuth(thunkAPI.getState());
    if (!token)
      return utils.rejectWithValue(thunkAPI, null, {
        logout: true,
        message: 'Null token',
      });

    const res = await axios.post(`/merchant/add/offer/${currBranch}`, offer, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.status === 200) {
      thunkAPI.dispatch(getOffers());
      return res.data;
    }
    return utils.rejectWithValue(thunkAPI, null, {
      message: res.data.message,
      status: res.status,
    });
  } catch (err) {
    return utils.rejectWithValue(thunkAPI, err);
  }
});

export const deleteOffer = createAsyncThunk('offer/deleteOffer', async (offerId, thunkAPI) => {
  try {
    const { currBranch, token } = utils.getAuth(thunkAPI.getState());
    if (!token)
      return utils.rejectWithValue(thunkAPI, null, {
        logout: true,
        message: 'Null token',
      });

    const res = await axios.delete(`/merchant/delete/offer/${currBranch}`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { offerId },
    });

    if (res.status === 200) {
      thunkAPI.dispatch(getOffers());
      thunkAPI.dispatch(getCounts());
      return res.data;
    }
    return utils.rejectWithValue(thunkAPI, null, {
      message: res.data.message,
      status: res.status,
    });
  } catch (err) {
    return utils.rejectWithValue(thunkAPI, err);
  }
});

export const updateOffer = createAsyncThunk('offer/updateOffer', async (offer, thunkAPI) => {
  try {
    const { currBranch, token } = utils.getAuth(thunkAPI.getState());
    if (!token)
      return utils.rejectWithValue(thunkAPI, null, {
        logout: true,
        message: 'Null token',
      });
    const res = await axios.post(`/merchant/update/res/offer/${currBranch}`, offer, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.status === 200) {
      thunkAPI.dispatch(getOffers());

      return res.data;
    }
    return utils.rejectWithValue(thunkAPI, null, {
      message: res.data.message,
      status: res.status,
    });
  } catch (err) {
    return utils.rejectWithValue(thunkAPI, err);
  }
});

export const getOfferDetails = createAsyncThunk(
  'offer/getOfferDetails',
  async (offerId, thunkAPI) => {
    try {
      const { currBranch, token } = utils.getAuth(thunkAPI.getState());
      if (!token)
        return utils.rejectWithValue(thunkAPI, null, {
          logout: true,
          message: 'Null token',
        });

      const res = await axios.get(`/merchant/offer/details/${currBranch}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { offerId },
      });

      if (res.status === 200) {
        thunkAPI.dispatch(getOffers());

        return res.data;
      }
      return utils.rejectWithValue(thunkAPI, null, {
        message: res.data.message,
        status: res.status,
      });
    } catch (err) {
      return utils.rejectWithValue(thunkAPI, err);
    }
  },
);

export const bulkDelete = createAsyncThunk('offer/bulkDelete', async (offers, thunkAPI) => {
  try {
    const { currBranch, token } = utils.getAuth(thunkAPI.getState());
    if (!token)
      return utils.rejectWithValue(thunkAPI, null, {
        logout: true,
        message: 'Null token',
      });
    const res = await axios.delete(`/merchant/delete/bulk/offers/${currBranch}`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { offers: JSON.stringify(offers) },
    });

    if (res.status == 200) {
      thunkAPI.dispatch(getOffers());
      thunkAPI.dispatch(getCounts());
      return res.data;
    }
    return utils.rejectWithValue(thunkAPI, null, {
      message: res.data.message,
      status: res.status,
    });
  } catch (err) {
    return utils.rejectWithValue(thunkAPI, err);
  }
});

export const bulkHide = createAsyncThunk('offer/bulkHide', async ({ type, offers }, thunkAPI) => {
  try {
    const { currBranch, token } = utils.getAuth(thunkAPI.getState());
    if (!token)
      return utils.rejectWithValue(thunkAPI, null, {
        logout: true,
        message: 'Null token',
      });

    const res = await axios.put(
      `/merchant/hide-unhide/offers/${currBranch}`,
      { type, offers: JSON.stringify(offers) },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    if (res.status == 200) {
      thunkAPI.dispatch(getOffers());
      return res.data;
    }
    return utils.rejectWithValue(thunkAPI, null, {
      message: res.data.message,
      status: res.status,
    });
  } catch (err) {
    return utils.rejectWithValue(thunkAPI, err);
  }
});

export const slice = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    clearState: (state, { payload }) => {
      utils.clearState(state, status, payload);
    },

    updateFilter: (state, { payload }) => {
      const key = Object.keys(payload)[0];
      state.filters = {
        ...state.filters,
        [key]: { ...state.filters[key], ...payload[key] },
      };
      return state;
    },
    setView: (state, { payload }) => {
      if (payload.offers) {
        state.offersView = payload.offers;
      }
      if (payload.pending) {
        state.pendingView = payload.pending;
      }
    },
  },
  extraReducers: {
    /*
        Get Offers
        */
    [getOffers.fulfilled]: (state, { payload }) => {
      const { data, message } = payload;
      state.offers = data.map((offer) => ({
        ...offer,
        photos: offer.photos,
      }));
      utils.handleSuccess(state.status.getOffers, {
        message: message,
        status: 200,
      });

      return state;
    },
    [getOffers.rejected]: (state, { payload }) =>
      utils.handleError(state.status.getOffers, payload?.data),
    [getOffers.pending]: (state) => utils.handleLoading(state.status.getOffers),

    /*
        Get Pending Offers
        */
    [getPendingOffers.fulfilled]: (state, { payload }) => {
      const { data, message } = payload;
      state.pendingOffers = data.map((offer) => ({
        ...offer,
        photos: offer.photos,
      }));
      utils.handleSuccess(state.status.getOffers, {
        message: message,
        status: 200,
      });

      return state;
    },
    [getPendingOffers.rejected]: (state, { payload }) =>
      utils.handleError(state.status.getPendingOffers, payload?.data),
    [getPendingOffers.pending]: (state) => utils.handleLoading(state.status.getPendingOffers),
    /*
        Add Offer
        */
    [addOffer.fulfilled]: (state, { payload }) => {
      const { data, message, permission } = payload;
      state.status.addOffer.permission = permission;

      utils.handleSuccess(state.status.addOffer, {
        message: message,
        status: 200,
      });

      return state;
    },
    [addOffer.rejected]: (state, { payload }) =>
      utils.handleError(state.status.addOffer, payload?.data),
    [addOffer.pending]: (state) => utils.handleLoading(state.status.addOffer),

    /*
        Delete Offer
        */
    [deleteOffer.fulfilled]: (state, { payload }) => {
      const { data, message } = payload;
      state.choice = data;

      utils.handleSuccess(state.status.deleteOffer, {
        message: message,
        status: 200,
      });

      return state;
    },
    [deleteOffer.rejected]: (state, { payload }) =>
      utils.handleError(state.status.deleteOffer, payload?.data),
    [deleteOffer.pending]: (state) => utils.handleLoading(state.status.deleteOffer),
    /*
        Update Offer
        */
    [updateOffer.fulfilled]: (state, { payload }) => {
      const { data, message, permission } = payload;
      state.status.updateOffer.permission = permission;

      utils.handleSuccess(state.status.updateOffer, {
        message: message,
        status: 200,
      });

      return state;
    },
    [updateOffer.rejected]: (state, { payload }) =>
      utils.handleError(state.status.updateOffer, payload?.data),
    [updateOffer.pending]: (state) => utils.handleLoading(state.status.updateOffer),

    /*
        Get Offer Details
        */
    [getOfferDetails.fulfilled]: (state, { payload }) => {
      const { data, message } = payload;
      state.offerDetails = data;

      utils.handleSuccess(state.status.getOfferDetails, {
        message: message,
        status: 200,
      });

      return state;
    },
    [getOfferDetails.rejected]: (state, { payload }) =>
      utils.handleError(state.status.getOfferDetails, payload?.data),
    [getOfferDetails.pending]: (state) => utils.handleLoading(state.status.getOfferDetails),

    /*
		Bulk Delete
        */
    [bulkDelete.fulfilled]: (state, { payload }) => {
      const { data, message } = payload;

      utils.handleSuccess(state.status.bulkDelete, {
        message,
        status: 200,
      });

      return state;
    },
    [bulkDelete.rejected]: (state, { payload }) =>
      utils.handleError(state.status.bulkDelete, payload?.data),
    [bulkDelete.pending]: (state) => utils.handleLoading(state.status.bulkDelete),

    /*
		Bulk Hide
        */
    [bulkHide.fulfilled]: (state, { payload }) => {
      const { data, message } = payload;
      utils.handleSuccess(state.status.bulkHide, {
        message,
        status: 200,
      });

      return state;
    },
    [bulkHide.rejected]: (state, { payload }) =>
      utils.handleError(state.status.bulkHide, payload?.data),
    [bulkHide.pending]: (state) => utils.handleLoading(state.status.bulkHide),
  },
});

export const { clearState, updateFilter, setView } = slice.actions;
export default slice.reducer;
